module.exports = __webpack_public_path__ + "static/media/clue0104.8ee72545.jpg";